import React, { useEffect, useState } from 'react';

import Button from './Button';
import Link from './renderers/Link';
import Notice from './Notice';
import { useApplicationDispatch } from '../contexts/application';

const CookieNotice = () => {
  const { dismissCookieNotice } = useApplicationDispatch();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 500);

    return () => clearTimeout(timer);
  });

  return (
    <Notice animateOn={show}>
      <div className="flex items-center">
        <p className="flex-1 mr-2 text-xs md:text-sm text-white">
          This site uses cookies to provide you with a better user experience.
          For more information, refer to our{' '}
          <Link href="/privacy" className="text-rose">
            Privacy Policy
          </Link>
        </p>
        <Button colour="pink" size="small" onClick={dismissCookieNotice}>
          Ok
        </Button>
      </div>
    </Notice>
  );
};

export default CookieNotice;
